// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

import { type Scope, useScope } from "~/hooks/useScope";
import { canGetPoliciesForAnalytics } from "./check";

export function useCanGetPoliciesForAnalytics(scope?: Scope): boolean {
  const { activeScope } = useScope();
  const withinScope = scope || activeScope;
  const canDoAction = !!withinScope && canGetPoliciesForAnalytics(withinScope);
  return canDoAction;
}
